import React from 'react';
import { connect } from 'react-redux';
import { updatePhaseTask, clearValidationErrors } from 'actionCreators';
import PhaseType from 'types/phase';
import TaskType from 'types/task';
import PropTypes from 'prop-types';
import PhaseTask from './phase_task';
import DeliveredModal from 'DeliveredModal';

export class Delivered extends PhaseTask {
  isDisabled = () => false

  onClick = () => {
    if (this.props.task.status === 'complete') this.toggleStatus();
    else this.setState({ modalActive: true });
  }

  renderChildren = () => {
    const { phase, task } = this.props;
    return (<DeliveredModal
      phase={phase}
      leadCertNumber={123456}
      task={task}
      active={this.state.modalActive}
      completeTask={this.completeTask}
      onClose={this.handleClose}
    />);
  }
}

Delivered.propTypes = {
  phase: PhaseType.isRequired,
  task: TaskType.isRequired,
  updatePhaseTask: PropTypes.func.isRequired,
};

export const delivered = connect(() => ({}),
{ updatePhaseTask, clearValidationErrors })(Delivered);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/tasks/delivered.jsx